var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#383939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9536 6.45694L12.4537 6.11325L13.0348 5.15644L12.4611 4.21537L11.7264 3.708L10.2172 3.375L9.28631 3.89981L7.79681 3.63431L5.75156 5.05125L5.59238 6.70613L4.72444 7.06838L4.82456 8.60344L4.21875 9.08606L4.824 10.8141L4.91512 10.9952L5.55525 12.7744L6.87094 13.2401L7.84631 14.2324L8.96794 14.625L9.47531 14.4788L10.2802 14.3859L11.4604 14.0479L13.2188 13.0551L12.7586 11.2371L11.8733 10.8883L11.4322 11.3929L10.1919 11.6978L8.388 11.412L7.80581 10.7387L8.00831 10.08L7.15556 8.73056L7.87275 7.85531L7.94925 6.3675L8.97638 5.778L9.68062 5.49675L10.6369 5.66944L10.9536 6.45694Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnd);
export default __webpack_public_path__ + "static/media/cnd.480251f4e0990298cda90d1a8cb90d41.svg";
export { ForwardRef as ReactComponent };